<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="articleAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="first_name" class="form-label">First name:</label>
                    <input id="first_name" class="form-control" name="first_name" v-model="formData.first_name" :class="checkValidation(classes)" placeholder="first name" type="text">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="last_name" class="form-label">Last name:</label>
                    <input id="last_name" class="form-control" name="last_name" v-model="formData.last_name" :class="checkValidation(classes)" placeholder="last name" type="text">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="phone" class="form-label">Phone:</label>
                    <input id="phone" class="form-control" name="phone" v-model="formData.phone" :class="checkValidation(classes)" placeholder="phone" type="text">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required|email" tag="div" class="form-group">
                    <label for="email" class="form-label">Email:</label>
                    <input id="email" class="form-control" name="email" v-model="formData.email" :class="checkValidation(classes)" placeholder="email" type="text">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="gender" class="form-label">Gender:</label>
                    <select id="gender" class="form-control" name="gender" v-model="formData.gender" :class="checkValidation(classes)">
                      <option value="female">female</option>
                      <option value="male">male</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider v-if="!isEdit" v-slot="{ classes }" vid="confirmation" rules="required|min:6" tag="div" class="form-group">
                    <label for="password" class="form-label">Password:</label>
                    <input id="password" class="form-control" name="password" v-model="formData.password" :class="checkValidation(classes)" placeholder="password" type="password">
                  </ValidationProvider>
                  <ValidationProvider v-if="!isEdit" v-slot="{ classes }" rules="required|min:6|confirmed:confirmation" tag="div" class="form-group">
                    <label for="confirm_password" class="form-label">Confirm Password:</label>
                    <input id="confirm_password" class="form-control" name="password_confirmation" v-model="formData.password_confirmation" :class="checkValidation(classes)" placeholder="confirm password" type="password">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Country:</label>
                    <multiselect v-model="formData.country" placeholder="Select country" :custom-label="customLabel" id="continent_id" :class="classes"  :close-on-select="true" track-by="id" :options="selectData">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'user'
const url = 'user'
export default {
  name: 'roomBaseAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      selectData: [],
      multipleFiles: [],
      articleCategory: [],
      formData: {
        title_l: {},
        content_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
    this.getCreateData().then((res) => {
      if (res.success) {
        this.selectData = res.data.countries
      }
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('articleAddForm')
          const formData = new FormData(form)
          formData.append('country_id', this.formData.country.id)
          if (this.isCreate === true) {
            this.create(formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            formData.append('_method', 'PUT')
            this.update({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
